/** @jsxImportSource @emotion/react */
import { Button } from "antd";
import ImageNotFoundPage from "assets/Common/images/page_not_found.png";
import HelmetCustom from "components/Common/HelmetCustom";
import Header from "components/Mobile/ui/Header";
import { PATH } from "contants/path";
import { Link } from "react-router-dom";

import NotFoundPageStyled from "./style.index";
const NotFoundPage = () => {
  return (
    <div css={NotFoundPageStyled.wrapper}>
      <div css={NotFoundPageStyled.header}>
        <Header />
      </div>
      <div css={NotFoundPageStyled.mainContent}>
        <HelmetCustom title="Page Not Found" />
        <img src={ImageNotFoundPage} alt="" />
        <h2>Page Not Found</h2>
        <div css={NotFoundPageStyled.describe}>
          We’re sorry, the page you requested could not be found Please go back
          to the homepage
        </div>
        <Link to={PATH.Home} css={NotFoundPageStyled.btn}>
          <Button type="primary">Go Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
